if(!customElements.get('bread-crumbs')) {
    class BreadCrumbs extends HTMLElement {
        constructor() {
            super();
        }
        connectedCallback() {
            this.selectors = {
                secondLevel: this.querySelector('.bread-crumbs-second-level'),
                separator: this.querySelector('.separator.second-level'),
                scrollable: this.querySelector('.scrollable')
            }
            // if(this.dataset.templateName === 'collection') {
            //     this.saveHandle();
            // }           
            // if(this.dataset.templateName === 'product' && this.getHandle()) {
            //     const secondLevel = this.querySelector('.bread-crumbs-second-level');
            //     if(secondLevel) {
            //         secondLevel.href = this.getHandle().url;
            //         secondLevel.textContent =  this.getHandle().title;
            //     } else {
            //         const thirdLevel = this.querySelector('.product-link');
            //         const secondLevelLink = document.createElement('a');
            //         secondLevelLink.href = this.getHandle().url;
            //         secondLevelLink.textContent = this.getHandle().title;
            //         secondLevelLink.classList.add('full-unstyled-link', 'bread-crumbs-second-level');
            //         this.insertBefore(secondLevelLink, thirdLevel);
            //         const secondLevelSeparator = document.createElement('span');
            //         secondLevelSeparator.classList.add('separator');
            //         secondLevelSeparator.setAttribute('aria-hidden', true);
            //         secondLevelSeparator.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M9 6l6 6-6 6"></path></svg>`;
            //         this.insertBefore(secondLevelSeparator, thirdLevel);
            //     }
            // }
            this.initScrollable();
        }
        initScrollable() {
            const scrollable = this.selectors.scrollable;
            const parent = this;

            let lastScrollLeft = scrollable.scrollLeft;

            const updateState = () => {
                const currentScrollLeft = scrollable.scrollLeft;
                const maxScroll = scrollable.scrollWidth - scrollable.clientWidth;

                // direction
                if (currentScrollLeft > lastScrollLeft) {
                    parent.classList.add('moving-right');
                    parent.classList.remove('moving-left');
                } else if (currentScrollLeft < lastScrollLeft) {
                    parent.classList.add('moving-left');
                    parent.classList.remove('moving-right');
                }

                // position
                parent.classList.remove('at-start', 'at-middle', 'at-end');

                if (currentScrollLeft <= 0) {
                    parent.classList.add('at-start');
                } else if (currentScrollLeft >= maxScroll - 1) {
                    parent.classList.add('at-end');
                } else {
                    parent.classList.add('at-middle');
                }

                lastScrollLeft = currentScrollLeft;
            };

            scrollable.addEventListener('scroll', updateState);

            // 👈 run once on init
            updateState();
        }
        saveHandle() {
            const breadCrumbsData = {
                title: this.dataset.collectionTitle,
                url: this.dataset.collectionUrl
            }
            localStorage.setItem("bread-crumbs", JSON.stringify(breadCrumbsData));
        }
        getHandle() {
            return JSON.parse(localStorage.getItem("bread-crumbs"));
        }
    }
    customElements.define('bread-crumbs', BreadCrumbs);
}